import { injectBaseConstantMethods } from "./BaseConstants";

export const ONBOARDING_SESSION_STATUS = {
    INTRO: "INTRO",
    REGULAR: "REGULAR"
};

const displayTextKeys = {
    [ONBOARDING_SESSION_STATUS.INTRO]: "Intro",
    [ONBOARDING_SESSION_STATUS.REGULAR]: "Regular"
};

const labelClass = {
    [ONBOARDING_SESSION_STATUS.INTRO]: "cs-badge-intro",
    [ONBOARDING_SESSION_STATUS.REGULAR]: "cs-badge-regular"
};

export default injectBaseConstantMethods(ONBOARDING_SESSION_STATUS, displayTextKeys, labelClass);
